<template>
    <div ref="scroll">
        <div class="content" ref="content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import BScroll from '@better-scroll/core'
import ResizeObserver from 'resize-observer-polyfill'
export default {
    props:{
        options:{
            type:Object,
            default: function () {
                return {  
                    click:true, 
                    probeType:3,
                    bounce: { 
                        top:false,
                        bottom:false
                    }
                    //mouseWheel: true
                }
            }
        }
    },
    data: function() {
        return {
            paused:true
        }
    },
    methods: {
        detectResizeWapper(){
            this.viewDetec=new ResizeObserver(()=>{
                this.$emit('resize',this.$refs.scroll);
                this.scroll.refresh();
            });
            this.viewDetec.observe(this.$refs.scroll);
        },
        detectResizeInner(){
            this.contentDetec=new ResizeObserver(()=>{
                this.scroll.refresh();
            });
            this.contentDetec.observe(this.$refs.content);
        },
        infoEvent(){
            this.scroll.on('touchEnd', () => {
                this.$emit('touchEnd',this.scroll);
            })
        }
    },
    updated(){
        this.scroll.refresh();
    },
    mounted(){
        this.scroll=new BScroll(this.$refs.scroll,this.options);
        this.infoEvent();
        this.detectResizeWapper();
        this.detectResizeInner();
        this.$emit('mounted',this.$refs.scroll);
        setTimeout(()=>{
            this.scroll.refresh();
        },500);
        
    },
    beforeDestroyed() {
        if(this.viewDetec) {
            this.viewDetec.disconnect()
            this.viewDetec.takeRecords()
            this.viewDetec = null
        }
    }
};
</script>
